<template>
  <div :style="{width: width, height: height}" id="chart" ref="chart"></div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    data: {
      required: true,
      type: Array,
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '350px',
    },
  },
  mounted() {
    this.generateGraphics();
  },
  data() {
    return {
      chart: {},
    };
  },
  computed: {
    ...mapGetters([
      'am4core',
      'am4Charts',
    ]),
  },
  methods: {
    loaded() {
      setTimeout(() => {
        this.$emit('update-step', 4);
      }, 500);
    },
    generateGraphics() {
      this.chart = this.am4core.create(this.$refs.chart, this.am4Charts.PieChart);

      this.chart.x = this.am4core.percent(-20);
      this.chart.height = this.am4core.percent(100);
      this.chart.data = this.data;
      this.chart.numberFormatter.decimalSeparator = ',';
      this.chart.numberFormatter.thousandsSeparator = '.';
      this.chart.numberFormatter.numberFormat = '#,###.##';
      this.chart.events.on('ready', () => this.loaded());
      const series = this.chart.series.push(new this.am4Charts.PieSeries());
      series.width = 50;
      series.alignLabels = false;
      series.dataFields.value = 'value';
      series.labels.template.weight = 10;
      series.dataFields.category = 'name';
      series.labels.template.fontSize = 10;
      series.ticks.template.disabled = true;
      series.labels.template.disabled = true;
      series.slices.template.strokeWidth = 2;
      series.labels.template.fontWeight = 200;
      series.slices.template.strokeOpacity = 1;

      series.slices.template.stroke = this.am4core.color('#fff');
      series.colors.list = [
        this.am4core.color('#fcae38'),
        this.am4core.color('#d6dbde'),
      ];
      // series.labels.template.bent = true;
      series.hiddenState.properties.opacity = 1;
      series.hiddenState.properties.endAngle = -90;
      series.hiddenState.properties.startAngle = -90;
      series.slices.template.states.getKey('active').properties.shiftRadius = 0;
      /* Add legend */
      this.chart.legend = new this.am4Charts.Legend();
      const legend = this.chart.legend;
      legend.width = 100;
      legend.fontSize = 10;
      legend.fontWeight = 500;
      legend.valign = 'top';
      legend.align = 'right';
      legend.useDefaultMarker = true;
      legend.valueLabels.template.text = '{value}';
      legend.parent = this.chart.chartContainer;

      const markers = this.chart.legend.markers.template;
      markers.width = 30;
      markers.height = 30;
    },
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.chart.data = this.data;
      },
    },
  },
};
</script>
<style scoped>
#chart {
  width: 80%;
  height: 100%;
}
#chart >>> .ampopup-content {
  background: #fff;
  height: 20vh !important;
  width: 30vw!important;
  border: 1px solid #f4f4f4;
  text-align: center;
}
</style>




// WEBPACK FOOTER //
// src/components/panelV2/Contactability/Pie.vue